import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
// Add REACT_APP_STRIPE_PUBLISHABLE_KEY to your .env file
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

export { stripePromise };

// Stripe Connect Configuration
export const STRIPE_CONNECT_CLIENT_ID = process.env.REACT_APP_STRIPE_CONNECT_CLIENT_ID;
export const PLATFORM_FEE_PERCENT = 5; // 5% platform fee

// Generate Stripe Connect OAuth URL for church onboarding
export const getStripeConnectUrl = (churchId) => {
  const redirectUri = `${window.location.origin}/.netlify/functions/stripe-connect-callback`;
  const baseUrl = 'https://connect.stripe.com/express/oauth/authorize';
  const params = new URLSearchParams({
    client_id: STRIPE_CONNECT_CLIENT_ID,
    state: churchId,
    redirect_uri: redirectUri,
    'stripe_user[business_type]': 'non_profit',
  });
  return `${baseUrl}?${params.toString()}`;
};

// Calculate platform fee from amount (in cents)
export const calculatePlatformFee = (amountCents) => {
  return Math.round(amountCents * (PLATFORM_FEE_PERCENT / 100));
};

// Calculate what church receives after platform fee
export const calculateChurchPayout = (amountCents) => {
  return amountCents - calculatePlatformFee(amountCents);
};

// Price IDs for different support tiers (create these in Stripe Dashboard)
// These are placeholder IDs - replace with your actual Stripe Price IDs
export const SUPPORT_PRICES = {
  oneTime: {
    5: 'price_5_one_time',
    10: 'price_10_one_time',
    25: 'price_25_one_time',
    50: 'price_50_one_time',
    100: 'price_100_one_time',
  },
  monthly: {
    5: 'price_5_monthly',
    10: 'price_10_monthly',
    25: 'price_25_monthly',
    50: 'price_50_monthly',
    100: 'price_100_monthly',
  }
};

// Stripe Payment Link - "Customer chooses amount" link
const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/bJeaEZ8co7Gx4jN1SY97G00';

// Create a checkout session URL for Stripe Payment Links
export const createPaymentLink = (amount, isMonthly = false) => {
  // Use the single "customer chooses amount" payment link
  // Stripe will let the user select or enter their amount
  return STRIPE_PAYMENT_LINK;
};

// Get the main payment link directly
export const getStripePaymentLink = () => STRIPE_PAYMENT_LINK;

// Helper to format currency
export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};
